module.exports = __webpack_public_path__ + "static/media/gide.697f8af8.pdf";